import { Stack, strIsNullOrEmpty, TextField, tryParseJSONObject } from '@fox/atoms';
import { useRef } from 'react';
import { ActionCentreFilterProps, Range } from './contracts';
export function NumberRangeFilter({ column, onChange, filter, align }: ActionCentreFilterProps) {
	const value = useRef<Range | undefined>(undefined);
	const parsedValue = filter?.filterValue ? tryParseJSONObject<Range>(filter?.filterValue) : undefined;

	return (
		<Stack direction={align} spacing={2}>
			<TextField
				fullWidth
				type="number"
				value={parsedValue?.gte ?? ''}
				onChange={e => {
					if (!strIsNullOrEmpty(e.target.value)) {
						value.current = { ...value.current, gte: e.target.value };
					} else {
						if (!value.current?.lte) {
							value.current = undefined;
						} else {
							value.current = { lte: value.current.lte };
						}
					}
					onChange(JSON.stringify(value.current));
				}}
				size="small"
				placeholder={`${column.title} (min)`}
			/>
			<TextField
				fullWidth
				type="number"
				value={parsedValue?.lte ?? ''}
				onChange={e => {
					if (!strIsNullOrEmpty(e.target.value)) {
						value.current = { ...value.current, lte: e.target.value };
					} else {
						if (!value.current?.gte) {
							value.current = undefined;
						} else {
							value.current = { gte: value.current.gte };
						}
					}
					onChange(JSON.stringify(value.current));
				}}
				size="small"
				placeholder={`${column.title} (max)`}
			/>
		</Stack>
	);
}
